import { useState } from 'react'
import { useBetween } from 'use-between'
import { BTGlobal } from '../../../utils/BTglobal/BTGlobal'
import { BTCreateContract3 } from '../BTContract/BTCreateContract3'
import { BTCreateContract4 } from '../BTContract/BTCreateContract4'
import { contStep2 } from '../form/StepContract2'
import { createContractSchemas } from '../ICreateContract'
import { BTCreateContract6 } from './BTCreateContract6'

const BTCreateContract2 = () => {
  const { btGridRef } = useBetween(BTGlobal)
  const { dataRow3, setDataRow3 } = useBetween(BTCreateContract3)
  const { dataRow4, setDataRow4 } = useBetween(BTCreateContract4)
  const { dataRow6, setDataRow6 } = useBetween(BTCreateContract6)
  const [contractSchemas, setContractSchemas] = useState(createContractSchemas[0])
  const [dataRow2, setDataRow2] = useState<contStep2[]>([])
  const [dataModelo, setDataModelo] = useState<any>()
  const addRowStructure = (props: any) => {
    let data = {
      fatherStructure: props.dataRow.fatherStructure,
      tolerance: props.dataRow.tolerance,
      allergens: props.dataRow.allergens,
      structure: props.dataRow.structure,
      // allowsStamp: props.dataRow.allowsStamp,
      id: props.dataRow.id,
    }
    setDataModelo(data)
  }

  const updateRow = (items: any) => {
    
    let dRow = dataRow2.slice()
    setDataRow2([])
    let newRow = dRow.filter((item) => {
      if (item.id === items.id) {
        item.allergens = items.allergens[0].text
        // item.allowsStamp = items.allowsStamp[0].text
        item.data = items
        item.fatherStructure = items.fatherStructure[0].text
        item.structure = items.structure
        item.tolerance = items.tolerance[0].text
      }
      return item
    })
    setDataRow2(newRow)
    if (btGridRef !== undefined) btGridRef.current.api.refreshServerSideStore({ purge: true })
  }

  const deleteRow = (props: any) => {
    const newRow3: any = dataRow3.filter(row => row.fatherStructure2 !== props.dataRow.structure);
    setDataRow3(newRow3)
    const newRow4: any = dataRow4.filter(row => row.fatherStructure3 != props.dataRow.structure);
    setDataRow4(newRow4);
    const newRow6: any = dataRow6.filter(row => row.fatherStructure4 != props.dataRow.structure);
    setDataRow6(newRow6);
    let rows = dataRow2.slice()
    let newRow = rows.filter((item) => {
      return item.idFatherStructure !== props.dataRow.idFatherStructure
        || item.idStructure !== props.dataRow.idStructure
    })
    setDataRow2(newRow)
  }

  return {
    contractSchemas,
    setContractSchemas,
    dataRow2,
    setDataRow2,
    updateRow,
    deleteRow,
    dataModelo,
    setDataModelo,
    addRowStructure,
  }
}
export { BTCreateContract2 }
